import React from 'react'
import {
  Container,
  Header,
  Message,
  Label,
  Icon,
  Form,
  TextArea
} from 'semantic-ui-react'
import {
  withRouter
} from 'react-router'
import queryString from 'query-string'

class ImportSelection extends React.Component {
  constructor(props) {
    super(props);
    // props: match, history, mode, selections
    console.log("match:", this.props.match);
    console.log("this.props.history", this.props.history);
    console.log("this.props.history.location", this.props.history.location);
    const query = this.props.history.location.search;
    console.log("query:", query);
    const queryValues = queryString.parse(query)
    console.log("queryValues:", queryValues);
    const decodedJsonString = decodeURIComponent(queryValues.json);
    console.log("decodedJsonString:", decodedJsonString);
    const selection = JSON.parse(decodedJsonString);
    //const selection = {items: {}, value: "a", text: "a"};
    console.log("selection:", selection);

    this.state = {
      id: selection.id,
      idError: this.getIdError(selection.id),
      author: selection.author?selection.author:'',
      name: selection.name?selection.name:'',
      description: selection.description?selection.description:'',
      selection: selection,
    }
  }
  getIdError = (id)=>{
    const existingSelection = this.props.selections.find(s=>s.id===id);
    return existingSelection?"A selection with this ID already exists":undefined;
  }
  handleIdChange = (e, {value})=>{
    console.log("ImportSelection::handleIdChange()", e, value);
    value = value.replace(/[^0-9a-zA-Z]/g, "");
    this.setState({
      id: value,
      idError: this.getIdError(value)
    });
  }
  handleChange = (e, { name, value })=>{
    console.log("ImportSelection::handleChange()", e, name, value);
    this.setState({ [name]: value });
  }
  handleSubmit = ()=>{
    console.log("ImportSelection::handleSubmit()");
    console.log("state:", this.state);
    const selection = {...this.state.selection};
    selection.id = this.state.id;
    selection.name = this.state.name;
    selection.author = this.state.author;
    selection.description = this.state.description;
    this.props.onImport(selection);
    this.props.history.push('/selection/'+selection.id);
  }
  render() {
    const keys = Object.keys(this.state.selection.items);
    const topicCount = keys.filter(k=>k.indexOf('.')>-1).length;
    const outcomeCount = keys.filter(k=>k.indexOf('o')>-1).length;
    return (
      <Container text style={{ marginTop: '7em', padding: '10px', background: 'white #fef0e7' }}>
        <Header as='h1' style={{color: '#f2711c'}}>
          <Header.Subheader style={{color: '#f7a56e'}}>Import Selection</Header.Subheader>
          {this.state.selection.name} <span style={{fontWeight: 'lighter', fontVariant: 'all-small-caps'}}>({this.state.selection.id})</span>
        </Header>
        <Message info icon>
          <Icon name='info circle'/>
          <Message.Content>
            <p>
              Someone shared this curriculum selection
              (with {topicCount} topics
              and {outcomeCount} learning outcomes)
              with you.
              If you want to explore, modify, and compare this selection,
              you can <strong>import</strong> it.
            </p>
          </Message.Content>
        </Message>

        <Header as='h2'>Import</Header>
        <p>
          Before importing,
          you may want to update the information about this selection
          (but you can always update this later, too):
        </p>
        <Form onSubmit={this.handleSubmit}>
          <Form.Group widths='equal'>
            <Form.Input
              fluid
              name='id'
              label='ID'
              error={!!this.state.idError}
              value={this.state.id}
              placeholder='Unique ID (e.g., abbreviation) of this selection'
              onChange={this.handleIdChange}
            />
        {
          this.state.idError?
            <Label basic color='red' pointing='left'>
              {this.state.idError}
            </Label>
          :<span></span>
        }
            <Form.Input
              fluid
              name='author'
              label='Author'
              value={this.state.author}
              placeholder='Who created this selection'
              onChange={this.handleChange}
            />
          </Form.Group>
          <Form.Input
            fluid
            name='name'
            label='Name'
            value={this.state.name}
            placeholder='Full name of this selection'
            onChange={this.handleChange}
          />
          <Form.TextArea
            name='description'
            label='Description'
            value={this.state.description}
            placeholder='Description of this selection...'
            onChange={this.handleChange}
          />
          <Form.Button disabled={!!this.state.idError} color='orange'>Import</Form.Button>
        </Form>

        <Header as='h2'>What's happening here?</Header>
        <p>
          The URL you used to arrive here includes (in its query parameters)
          information about a selection of curriculum items.
          If you click the "Import" button above,
          this information will be stored in your browser's local storage,
          and you will be able to interactively explore and modify the selection of items.
        </p>
        <p>
          Here is the JSON defining the selection you are about to import:
        </p>
        <Form>
          <TextArea disabled autoHeight value={JSON.stringify(this.state.selection, null, ' ')}/>
        </Form>
      </Container>
    );
  }
}

export default withRouter(ImportSelection)